/**
 * useDriverLicenseMask
 *
 * Инкапсулирует логику определения маски для серии/номера
 * водительского удостоверения.
 *
 * Используется как в карточке водителя, так и в обработчике вставки.
 */
export function useDriverLicenseMask() {
  /**
   * Определяет маску по первому символу номера.
   * @param {string} value
   * @returns {string} маска для v-text-field
   */
  function resolveMask(value) {
    if (!value) return 'S'
    const firstChar = value.replace(/\s/g, '').charAt(0)
    if (/^[A-Za-zА-Яа-яЁё]$/.test(firstChar)) return 'RR ######'
    if (/^\d$/.test(firstChar)) return '##SS ######'
    return 'S'
  }

  /**
   * Форматирует вставленный текст под стандартный вид "СЕРИЯ НОМЕР".
   * @param {string} raw — текст из буфера обмена (без пробелов)
   * @returns {string}
   */
  function formatPastedLicenseNumber(raw) {
    const clean = raw.replace(/\s+/g, '')
    if (
      /^\d{2}[A-Za-zА-Яа-яЁё\d]{2}\d{6}$/.test(clean) ||
      /^\d{10}$/.test(clean)
    ) {
      return `${clean.slice(0, 4)} ${clean.slice(4)}`
    }
    return clean
  }

  return { resolveMask, formatPastedLicenseNumber }
}



// WEBPACK FOOTER //
// ./resources/js/components/change/composables/useDriverLicenseMask.js